define('modules/editor/views/correodirect_forms',['require','exports','module','base/collectionview','./correodirect_forms_empty_view','./correodirect_forms_itemview'],function(require, exports, module){
  "use strict";

  var CollectionView = require("base/collectionview"),
      EmptyFields = require("./correodirect_forms_empty_view"),
      Form = require("./correodirect_forms_itemview");

  module.exports = CollectionView.extend({
    tagName: "form",
    className: "row",
    //template: require("ldsh!../templates/correodirect_forms"),
    //itemContainer: "#js-forms",
    emptyViewType: EmptyFields,
    itemView: Form,
    onRender: function() {
      this.$el.i18n();
    }
  });
});

